import * as _ from "./util/lodash";
import ConfigService from "./services/config-service";

function init(config) {
  if (_.get(config, 'globalContext') === undefined) {
    throw new Error("Unexpected format for config object. Expected property \"globalContext\" to be defined.");
  }

  ConfigService.setConfig(config.globalContext);
}

export default {
  init: init
};
//# sourceMappingURL=bootstrapper.js.map